import React from "react"
import PropTypes from "prop-types"

export const Confirmed = ({ height = 20, width = 20, fill = "#272A34", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17 1L6 12L1 7" stroke="#B7B7B7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

Confirmed.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}